import { axiosInstance } from "./apiInstance";

export const getCompanyGroups = () => {
  const response = axiosInstance.get("/api/inkle/company/v1/my_groups/");
  return response;
};
